import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";
import api from "../../api/axios"
import ProjectForm from "../../components/forms/ProjectForm";

function CreateProject() {

  return (
    <>
      <Header/>
      <div className="p-6 flex items-center justify-between">
        <h1 className="text-xl font-semibold">새 프로젝트 등록</h1>
      </div>

      <ProjectForm />
    </>
  );
}

export default CreateProject;